module.exports = __webpack_public_path__ + "static/media/noun_Question_3013473 1.7b1b332a.svg";